import React from 'react';
import Paper from '@mui/material/Paper';
import { clsx } from 'clsx';
import { LwtCopyrightDoubleLines } from 'html-worksheets/@common/LwtCopyright';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';

const LandscapePaperLayout = ({
  children,
  className,
  isWide = false,
  isExtraWide = false,
  noFooterText = false,
  paddingTop = 70,
  printRef,
  sx,
  wrapperStyles = {},
  ...props
}: any) => {
  const classes = useStyles();
  return (
    <Paper
      id={'print-content-landscape'}
      className={clsx(classes.landscapeContainerClass, className)}
      ref={printRef}
      sx={sx}
      {...props}
    >
      <Box className={classes.wrapper} sx={wrapperStyles}>
        {children}
      </Box>
      <LwtCopyrightDoubleLines
        isLandscape
        isWide={isWide}
        isExtraWide={isExtraWide}
        noFooterText={noFooterText}
      />
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  landscapeContainerClass: () => {
    return {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '1100px',
      height: '850px !important',
      position: 'relative',
      margin: '0 auto',
      minWidth: 'unset !important'
    };
  },
  wrapper: () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '1100px',
    height: '850px !important',
    position: 'relative',
    padding: '32px'
  })
}));

export default LandscapePaperLayout;
